module.exports = __webpack_public_path__ + "img/supervision_960.b459ada8.png";